import { useEffect, useState } from "react";

const TYPE_DELAY_MS = 650;
const TYPE_STEP_MS = 42;

/** Types `text` out one character at a time; reduced motion shows it whole at once. */
export function useTypedText(text: string) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setCount(text.length);
      return;
    }
    setCount(0);
    let interval: ReturnType<typeof setInterval> | undefined;
    const start = setTimeout(() => {
      interval = setInterval(() => {
        setCount((n) => {
          if (n + 1 >= text.length && interval) clearInterval(interval);
          return Math.min(n + 1, text.length);
        });
      }, TYPE_STEP_MS);
    }, TYPE_DELAY_MS);
    return () => {
      clearTimeout(start);
      if (interval) clearInterval(interval);
    };
  }, [text]);
  return { typed: text.slice(0, count), done: count >= text.length };
}
